document.addEventListener('DOMContentLoaded', () => {
  const art = document.querySelector('[data-hero-art]');
  const heroVideo = document.querySelector('[data-hero-video]');
  if (heroVideo && art) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      heroVideo.pause();
      heroVideo.removeAttribute('autoplay');
    } else {
      const markPlaying = () => art.classList.add('is-playing');
      heroVideo.addEventListener('playing', markPlaying, { once: true });
      const play = heroVideo.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    }
  }

  const toggle = document.querySelector('[data-menu-toggle]');
  const panel = document.querySelector('[data-mobile-panel]');

  if (toggle && panel) {
    const setOpen = (open) => {
      panel.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', String(open));
    };
    toggle.addEventListener('click', () => setOpen(!panel.classList.contains('open')));
    panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && panel.classList.contains('open')) {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  const lightbox = document.querySelector('[data-lightbox]');
  const photos = [...document.querySelectorAll('[data-lightbox-item]')];
  if (lightbox && photos.length && typeof lightbox.showModal === 'function') {
    const image = lightbox.querySelector('[data-lightbox-image]');
    const caption = lightbox.querySelector('[data-lightbox-caption]');
    const prev = lightbox.querySelector('[data-lightbox-prev]');
    const next = lightbox.querySelector('[data-lightbox-next]');
    let current = 0;
    const show = (index) => {
      current = (index + photos.length) % photos.length;
      const photo = photos[current];
      const thumb = photo.querySelector('img');
      image.width = Number(thumb?.getAttribute('width')) || 1000;
      image.height = Number(thumb?.getAttribute('height')) || 1000;
      image.src = photo.href;
      image.alt = thumb?.alt || '';
      caption.textContent = photo.dataset.caption || '';
      caption.hidden = !caption.textContent;
    };
    prev.hidden = next.hidden = photos.length < 2;
    photos.forEach((photo, index) => photo.addEventListener('click', (event) => {
      event.preventDefault();
      show(index);
      lightbox.showModal();
    }));
    prev.addEventListener('click', () => show(current - 1));
    next.addEventListener('click', () => show(current + 1));
    lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox || event.target.tagName === 'FIGURE') lightbox.close();
    });
    lightbox.addEventListener('keydown', (event) => {
      if (photos.length < 2) return;
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });
    lightbox.addEventListener('close', () => photos[current].focus());
  }

  // The custom-project form goes to the store's request function. A filled honeypot is ignored.
  const previewForm = document.querySelector('[data-preview-form]');
  if (previewForm) {
    previewForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const status = previewForm.querySelector('[data-form-status]');
      const cfg = window.CD_BOARD_CONFIG;
      const data = Object.fromEntries(new FormData(previewForm));
      status.hidden = false;
      if (!cfg) {
        status.textContent = 'Preview only — nothing was sent.';
        return;
      }
      status.textContent = 'Sending…';
      try {
        const res = await fetch(`${cfg.supabaseUrl}/functions/v1/custom-request`, {
          method: 'POST',
          headers: { 'content-type': 'application/json', apikey: cfg.supabaseKey },
          body: JSON.stringify(data),
        });
        const body = await res.json().catch(() => ({}));
        if (!res.ok) { status.textContent = body.message || 'Could not send the request.'; return; }
        previewForm.reset();
        status.textContent = 'Received. We’ll reply by email.';
      } catch {
        status.textContent = 'Could not send the request. Check your connection and try again.';
      }
    });
  }
});
